import React from 'react';
import AsyncAccountSettings from './accountsettings/updateaccount/async';
import AsyncTeamSettings from './teamsettings/async';
import AsyncDevices from './devices/async';
import AsyncStoreManagement from './store/async';
import AsyncSortStore from './store/sortstore/async';
import AsyncRoleManagements from './teamsettings/rolemanagements/async';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';
import profile from './accountsettings/routes';

const parent = {
  title: <Trans i18nKey="p.generalsettings.title">General Settings</Trans>,
  path: '/general-settings',
};

const parent1 = {
  title: <Trans i18nKey="p.generalsettings.title">General Settings</Trans>,
  path: '/general-settings/devices',
};

const parent2 = {
  title: <Trans i18nKey="p.g.team.settings.title">Team Settings</Trans>,
  path: '/general-settings/team-settings',
};

export default [
  <SingleColumnLayout
    exact
    key="a"
    className="kt-portlet--solid-gray"
    path="/general-settings/account-settings"
    component={AsyncAccountSettings}
    title={<Trans i18nKey="p.g.account.settings.title">Account Settings</Trans>}
    parents={[parent]}
  />,
  <SingleColumnLayout
    exact
    key="c"
    className="kt-portlet--solid-gray"
    path="/general-settings/team-settings"
    component={AsyncTeamSettings}
    title={<Trans i18nKey="p.g.team.settings.title">Team Settings</Trans>}
    parents={[parent]}
  />,
  <Redirect
    key="f"
    exact
    from="/general-settings"
    to="/general-settings/account-settings"
  />,
  <SingleColumnLayout
    exact
    key="g"
    path="/general-settings/devices"
    component={AsyncDevices}
    title={<Trans i18nKey="c.l.sidebar.9160.title.v2">License</Trans>}
    parents={[parent1]}
  />,
  <SingleColumnLayout
    exact
    key="j"
    path="/general-settings/location-management"
    component={AsyncStoreManagement}
    title={
      <Trans i18nKey="p.g.store.management.title">Location Management</Trans>
    }
    parents={[parent]}
  />,
  <SingleColumnLayout
    exact
    key="h"
    path="/general-settings/location-management/sort-location"
    component={AsyncSortStore}
    title={
      <Trans i18nKey="p.g.store.management.title">Location Management</Trans>
    }
    parents={[parent]}
  />,
  <SingleColumnLayout
    exact
    key="h"
    path="/general-settings/role-management"
    component={AsyncRoleManagements}
    title={<Trans i18nKey="p.g.role.management.title">Role Management</Trans>}
    parents={[parent2]}
  />,
  profile,
];
